import React, { useEffect, useState } from 'react';
import { BottomSheet, Button, Terms, LoadingBubble } from '@encarpkg/design';
import { postInquiryAgreements } from '@encarpkg/api';
import useInquiry from 'app/hook/buyInquiry/useInquiry';
import { loggingException } from 'app/libs/sentry';
import useEnlog from 'app/hook/common/useEnlog';
import useSsrCookie from 'app/hook/common/useSsrCookie';

function camelToSnake(str) {
	return str.replace(/([a-z])([A-Z])/g, '$1_$2');
}

function LayerTerms({ onSubmit, onClose }) {
	const [loading, setLoading] = useState(false);
	const { getCookie } = useSsrCookie();
	const { enloggingJsonData } = useEnlog();

	const pcId = getCookie('PCID') || '';

	useEffect(() => {
		const dataTalkViewSingle = {
			eventNameGroup: '구매문의약관동의',
		};
		enloggingJsonData({
			dataTalkViewSingle,
		});
	}, [enloggingJsonData]);

	const { phoneNumber, termsAgreement, changeTermsInfo } = useInquiry();
	const { personal, thirdPartyConsent } = termsAgreement;

	const handleTermsChange = ({ name, checked }) => {
		changeTermsInfo({ name, value: checked });
	};

	const handleTermsConfirm = async () => {
		try {
			setLoading(true);
			const agreementType = Object.keys(termsAgreement).filter((key) => termsAgreement[key] === true);
			const params = {
				contactNumber: phoneNumber,
				pcid: pcId,
				agreementType: agreementType.map((v) => camelToSnake(v).toUpperCase()),
				agreed: true,
			};
			// 구매문의 약관 동의 내역 저장
			await postInquiryAgreements(params);
			// 판매자 메세지 발송
			await onSubmit({ eventNameGroup: '전화번호인증' });
		} catch (e) {
			loggingException(e);
		} finally {
			setLoading(false);
		}
	};
	return (
		<BottomSheet
			isOpen
			dimClosable
			hasCloseBtn
			header={
				<strong
					style={{
						display: 'block',
						fontSize: '18px',
						fontWeight: '600',
						lineHeight: '29px',
						marginBottom: '12px',
					}}
				>
					구매문의를 남기기 위해
					<br />
					약관 동의가 필요해요
				</strong>
			}
			customStyles={{ padding: '20px' }}
			onClose={onClose}
			data-enlog-dt-eventnamegroup="구매문의약관동의"
		>
			{loading && <LoadingBubble />}
			<Terms.V2
				allCheckLabel="약관 전체 동의"
				onChange={handleTermsChange}
				termsList={[
					{
						name: 'personal',
						label: '개인정보 수집 및 이용에 대한 동의',
						link: `${window.location.origin}/buyinquiry/privacy?type=personal`,
						target: '_blank',
						isRequired: true,
						active: personal,
					},
					{
						name: 'thirdPartyConsent',
						label: '개인정보 제3자 제공에 대한 동의',
						link: `${window.location.origin}/buyinquiry/privacy?type=thirdPartyConsent`,
						target: '_blank',
						isRequired: true,
						active: thirdPartyConsent,
					},
				]}
				data-enlog-dt-eventnamegroup="구매문의약관동의"
			/>
			<Button.V2
				domType="button"
				onClick={() => {
					handleTermsConfirm();
				}}
				data-enlog-dt-eventnamegroup="구매문의약관동의"
				style={{ marginTop: '20px' }}
				disabled={!(personal && thirdPartyConsent)}
			>
				확인
			</Button.V2>
		</BottomSheet>
	);
}

export default LayerTerms;
